import { useState } from "react";
import { FaRegCircleCheck } from "react-icons/fa6";
import { MdOutlineContentCopy } from "react-icons/md";

export const Copy = ({ showText = true, text, ...props }) => {
   const [success, setSuccess] = useState(false);

   function onCopyClick(event) {
      setSuccess(true);
      navigator.clipboard.writeText(text);
      setTimeout(() => setSuccess(false), 2500);
   }

   return (
      <button {...props} onClick={onCopyClick} className={`relative inline-flex items-center gap-1 hover:opacity-75 duration-150 ${props.className} ${success ? 'text-green-500 pointer-events-none! duration-300' : ''}`}>
         {success && (
            <div className="absolute flex flex-row gap-1 items-center left-0 top-1/2 -translate-y-1/2">
               <FaRegCircleCheck size={14} className="print:hidden" />
               Copiado!
            </div>
         )}
         <div className={`flex flex-row gap-1 items-center ${success ? 'opacity-0!' : ''}`}>
            <MdOutlineContentCopy size={14} className="print:hidden" />
            {showText ? text : 'Copiar'}
         </div>
      </button >
   );
}